import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "circle-misc",
  "use": "circle-misc-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"circle-misc\"><rect width=\"32\" height=\"32\" rx=\"16\" fill=\"#6F8EDB\" /><rect x=\"4\" y=\"13\" width=\"6\" height=\"6\" rx=\"3\" fill=\"#fff\" /><rect x=\"13\" y=\"13\" width=\"6\" height=\"6\" rx=\"3\" fill=\"#fff\" fill-opacity=\".8\" /><rect x=\"22\" y=\"13\" width=\"6\" height=\"6\" rx=\"3\" fill=\"#fff\" fill-opacity=\".6\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol